import styled from 'styled-components';

import { media } from '../../styles/constants';

const WorkdetailCardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media (min-width: ${media.tabletPortrait}) {
    margin-right: -2rem;
  }

  @media (min-width: ${media.desktop}) {
    margin-right: -3rem;
  }

  /* [Style] Tweak here to change the layout of each card */
  > a,
  > div {
    margin-bottom: 2rem;
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 100%;

    @media (min-width: ${media.tabletPortrait}) {
      margin-right: 2rem;
      margin-bottom: 2rem;
      flex-grow: 0;
      flex-basis: calc(50% - 2rem);
    }

    @media (min-width: ${media.desktop}) {
      margin-right: 3rem;
      margin-bottom: 3rem;
      flex-basis: calc(50% - 3rem);
    }
  }

  > div:nth-child(2n) {
    margin-right: 0;
  }
`;

export default WorkdetailCardContainer;
